"use client";

import { useLocationState } from "@rangojs/router/client";
import { FlashMessage } from "../location-states";

export function FlashBanner() {
  const flash = useLocationState(FlashMessage);

  if (!flash) return null;

  const isError = flash.type === "error";

  return (
    <div
      className={`mb-6 px-4 py-3 rounded-lg text-sm font-medium ${
        isError
          ? "bg-red-50 text-red-700 border border-red-200"
          : "bg-green-50 text-green-700 border border-green-200"
      }`}
    >
      {flash.text}
    </div>
  );
}
